/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum RegisterObjectType {
  Register = 0,
  Asset = 1,
}
